export const makeXhrRequest = (
  url: string,
  method: "GET" | "POST",
  headers: Record<string, string>,
  body: string,
  onSuccess: (data: any) => void,
  onError: (errorMessage: string) => void,
  onComplete?: () => void
) => {
  const xhr = new XMLHttpRequest();

  xhr.open(method, url, true);

  // Ajouter les headers
  Object.entries(headers).forEach(([key, value]) => {
    xhr.setRequestHeader(key, value);
  });

  // Gestion des états
  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (onComplete) onComplete(); // Appeler la fonction onComplete, si fournie

      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const trimmedResponse = xhr.responseText.trim();
          if (trimmedResponse.startsWith("{") || trimmedResponse.startsWith("[")) {
            const data = JSON.parse(trimmedResponse);
            onSuccess(data);
          } else {
            onError(`Erreur de format de réponse : ${xhr.responseText}`);
          }
        } catch (err) {
          console.error("Erreur JSON :", err);
          onError("Erreur lors du traitement de la réponse");
        }
      } else {
        console.error("Statut XHR non réussi :", xhr.status);
        onError("La requête a échoué : vérifiez vos paramètres");
      }
    }
  };

  // Gestion des erreurs réseau
  xhr.onerror = () => {
    if (onComplete) onComplete(); // Appeler la fonction onComplete en cas d'erreur réseau
    onError("Une erreur réseau est survenue");
  };

  xhr.send(body);
};